module.exports = __webpack_public_path__ + "img/chanjet.b593773b.png";